// @flow
import { ProductCommunityQuestionsLine } from 'Components/lines/product-community-questions-line/ProductCommunityQuestionsLine';
import { PRODUCT_COMMUNITY_QUESTIONS } from 'Client/cms/toolkit/constants';
import { productCommunityQuestionsResolver } from './productCommunityQuestions.resolver';

export const productCommunityQuestionsDescriptor = {
  name: PRODUCT_COMMUNITY_QUESTIONS,
  component: ProductCommunityQuestionsLine,
  resolve: productCommunityQuestionsResolver.resolve,
};
